import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { useTranslation } from './utils/i18n';
import MainLayout from './layouts/MainLayout';
import LoginPage from './pages/LoginPage';
import KakaoCallbackPage from './pages/KakaoCallbackPage';
import HomePage from './pages/HomePage';
import WorkPage from './pages/WorkPage';
import NotificationsPage from './pages/NotificationsPage';
import SettingsPage from './pages/SettingsPage';
import ProfilePage from './pages/ProfilePage';
import ComingSoonPage from './pages/ComingSoonPage';
import PWAInstallPrompt from './components/PWAInstallPrompt';

// Loan service pages
import CustomerListPage from './services/loan/CustomerListPage';
import CustomerFormPage from './services/loan/CustomerFormPage';
import LoanFormPage from './services/loan/LoanFormPage';
import LoanListPage from './services/loan/LoanListPage';
import LoanDetailPage from './services/loan/LoanDetailPage';
import LoanIncreaseRequestPage from './services/loan/LoanIncreaseRequestPage';
import CommissionPage from './services/loan/CommissionPage';
import PaymentRequestPage from './services/loan/PaymentRequestPage';
import CreatePaymentRequestPage from './services/loan/CreatePaymentRequestPage';
import BankSelectionPage from './services/loan/BankSelectionPage';
import EditLoanDraftPage from './services/loan/EditLoanDraftPage';

function PrivateRoute({ children }) {
  const { user, loading, language } = useAuth();
  const { t } = useTranslation(language);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>{t('loading')}</p>
      </div>
    );
  }

  return user ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/kakao/callback" element={<KakaoCallbackPage />} />

        {/* Private routes with layout */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<HomePage />} />
          <Route path="work" element={<WorkPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="coming-soon" element={<ComingSoonPage />} />

          {/* Loan service routes */}
          <Route path="loan">
            <Route path="customers" element={<CustomerListPage />} />
            <Route path="customers/new" element={<CustomerFormPage />} />
            <Route path="customers/edit/:id" element={<CustomerFormPage />} />

            <Route path="new" element={<LoanFormPage />} />
            <Route path="edit/:id" element={<EditLoanDraftPage />} />
            <Route path="select-bank" element={<BankSelectionPage />} />
            <Route path="list" element={<LoanListPage />} />
            <Route path="detail/:id" element={<LoanDetailPage />} />
            <Route path="increase-request" element={<LoanIncreaseRequestPage />} />

            <Route path="commission" element={<CommissionPage />} />
            <Route path="payment-request" element={<PaymentRequestPage />} />
            <Route path="payment-request/create" element={<CreatePaymentRequestPage />} />
          </Route>
        </Route>

        {/* 404 */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>

      {/* PWA Install Prompt */}
      <PWAInstallPrompt />
    </>
  );
}

export default App;
